export default __webpack_public_path__ + "static/media/q11_step2.b0ebc9c4.png";